<template>
  <div
    style="width: 100vw; height: calc(100vh); top: 20px; overflow: hidden"
    class="background"
  >
    <div
      :style="distanceTop"
      class="px-6 pb-6 d-flex flex-column"
      style="
        height: 80vh;
        overflow-y: scroll;
        position: fixed;
        width: 100%;
        margin-top: 12vh;
        scrollbar-width: none;
      "
    >
      <div
        v-for="tour in tours"
        :key="tour.id + tour.name"
        class="d-flex flex-column"
        @click="$router.push(`/tour/${tour.id}`)"
      >
        <div class="d-flex justify-space-between py-4">
          <div class="white--text">
            {{ tour.name }}
          </div>

          <div v-if="tour.tour" class="d-flex align-center justify-center">
            <div class="d-flex align-center">
              <img
                src="@/assets/icons/poi-white.svg"
                style="height: 15px; width: auto"
              />
              <div class="white--text ml-1" style="font-size: 14px">
                {{ tour.count }}
              </div>
            </div>
            <div
              style="height: 20px; width: 0.5px; margin: 0 10px"
              class="white"
            ></div>
            <div class="d-flex align-center">
              <img
                src="@/assets/icons/tour.svg"
                style="height: 15px; width: auto"
              />
              <div class="white--text ml-1" style="font-size: 14px">
                {{ getTime(tour.length_chilometer) }}’
              </div>
            </div>
          </div>
        </div>

        <v-divider class="white"></v-divider>
      </div>
    </div>

    <button
      style="position: absolute; bottom: 30px; right: 30px; z-index: 999"
      :style="$vuetify.breakpoint.xs ? 'right: 10px' : 'right: 30px'"
      @click="$emit('close')"
    >
      <div
        class="primary white--text d-flex align-center justify-space-between"
        style="
          text-align: center;
          height: 35px;
          width: auto;
          z-index: 100;
          border-radius: 18px;
          font-size: 16px;
          border: 1px solid white !important;
        "
      >
        <span class="pl-4 mr-16"> {{ $t("buttons.map") }} </span>

        <div class="white mr-1" style="border-radius: 100px; height: 24px">
          <img
            src="@/assets/icons/map/map_closed.png"
            style="height: 15px; width: auto"
            class="mx-1 my-1"
            @click="$emit('close')"
          />
        </div>
      </div>
    </button>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  props: {
    tours: Array,
  },

  computed: {
    ...mapState({
      insets: (state) => state.base.insets,
    }),

    distanceTop() {
      return `margin-top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      } + 12vh)`;
    },
  },

  destroyed() {
    this.setMenuIconColor("blue");
  },

  methods: {
    ...mapMutations(["setMenuIconColor"]),

    getTime(time) {
      return `${time.split(".")[1]}’`;
    },
  },
};
</script>

<style scoped lang="scss"></style>
